module.exports = __webpack_public_path__ + "img/BlinkArt_Sword9_White.c1d073d8.png";